import { ENV_PREFIX } from './constants';

export type EnvVariable = 'ENVIRONMENT' | 'TARGET_PLATFORM' | 'AUTH_API_URL' | 'CLIENT_PORTAL_API_URL' | 'ISP_API_URL';

function getEnvVariable(name: EnvVariable): string {
  if (import.meta.env.PROD) {
    return (window.__ENV && window.__ENV[name]) ?? '';
  }
  return import.meta.env[`${ENV_PREFIX}${name}`] ?? '';
}

export default getEnvVariable;
